import { useCallback, useEffect, useState } from "react";

interface QuizProgressBarProps {
  branchedQuestionsCount: number;
  quizQuestionsCount: number;
  questionsAnsweredCount: number;
}

export const QuizProgressBar: React.FC<QuizProgressBarProps> = (props) => {
  const [completed, setCompleted] = useState(0);

  const calcProgress = useCallback((): number => {
    return Math.floor(
      (props.questionsAnsweredCount * 100) /
        (props.quizQuestionsCount - props.branchedQuestionsCount)
    );
  }, [
    props.quizQuestionsCount,
    props.questionsAnsweredCount,
    props.branchedQuestionsCount,
  ]);

  useEffect(() => {
    setCompleted(calcProgress);
  }, [props.questionsAnsweredCount, calcProgress, completed]);

  return (
    <div
      key={completed}
      className="lander__quiz__header--progress-bar--container"
    >
      <div className="progress-bar-container">
        <div
          className="progress-bar-indicator"
          style={{
            width: `${completed}%`,
          }}
        />
      </div>
    </div>
  );
};
